"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "corte-de-frati": {
    "71ee1256": [{
      "hkey": "840631e4",
      "slug": "corte-de-frati",
      "name": "Corte de' Frati",
      "primary": true,
      "skipSearch": false
    }],
    "aspice": [{
      "hkey": "840631e4",
      "slug": "corte-de-frati",
      "name": "Corte de' Frati",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "fd11a6e8": [{
      "hkey": "840631e4",
      "slug": "corte-de-frati",
      "name": "Corte de' Frati",
      "primary": true,
      "skipSearch": false
    }],
    "grumone": [{
      "hkey": "840631e4",
      "slug": "corte-de-frati",
      "name": "Corte de' Frati",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;